export function attempt<T>(fn: () => T): T | undefined {
    try {
        return fn();
    } catch (ex) {
        return undefined;
    }
}
